import BackArrowIcon from '@nv/images/design/back-arrow-icon'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { NVButton } from '../nv_button/NVButton'

export const BackBtn = ({ navigateTo = '', onClick, label }: any) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const defaultOnClick = () => (navigateTo ? navigate(navigateTo) : navigate(-1))

  return (
    <NVButton
      variant='text'
      onClick={onClick && !navigateTo ? onClick : defaultOnClick}
      icon={<BackArrowIcon />}
      text={label || t('buttons.back')}
      role='link'
    />
  )
}
